export default __webpack_public_path__ + "static/media/releaseNotes.31d6cfe0.md";